import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveModuleId } from '../lib/navRouteMatchers';
import { useShellStore } from '../store/shellStore';

/**
 * Keeps `activeModule` derived from the route (M1 · 86d44z1g9).
 *
 * A rail click writes `activeModule` directly, but that write is deliberately transient — this
 * effect re-resolves it on the next navigation, so the panel always ends up showing the module
 * the user is actually inside rather than the last one they poked at.
 *
 * Mount ONCE, in AppLayout. A second mount is harmless but pointless.
 */
export function useSyncActiveModuleToRoute(): void {
  const { pathname } = useLocation();
  const setActiveModuleFromRoute = useShellStore((s) => s.setActiveModuleFromRoute);

  useEffect(() => {
    // `null` (a module-less route such as /profile) is ignored by the store, so the panel behind
    // the profile page keeps showing whatever module the user came from.
    setActiveModuleFromRoute(resolveModuleId(pathname));
  }, [pathname, setActiveModuleFromRoute]);
}
